var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7586 0.5 39.5 9.11795 39.5 19.6924V19.6943C39.5353 27.4218 34.6489 34.6852 29.6602 40.0664C27.1756 42.7463 24.6871 44.9367 22.8193 46.457C21.8859 47.2168 21.1085 47.8089 20.5654 48.21C20.3312 48.3829 20.1397 48.519 19.999 48.6191C18.8093 47.7817 14.3905 44.5752 10.0557 39.8662C5.16582 34.5542 0.464777 27.4202 0.5 19.6826V19.6797C0.500172 9.11791 9.24132 0.500002 20 0.5ZM20 9.3457C14.2062 9.34571 9.5 13.969 9.5 19.6924C9.50004 25.4158 14.2063 30.0381 20 30.0381C25.7937 30.0381 30.5 25.4158 30.5 19.6924C30.5 13.969 25.7938 9.3457 20 9.3457Z",
    fill: "black",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin1);
export default __webpack_public_path__ + "static/media/pin1.b28969b03d604b3571da07267736f71f.svg";
export { ForwardRef as ReactComponent };